export default __webpack_public_path__ + "static/media/refer-blue.2d99e5ac.svg";